import { useCallback } from 'react';

import { useVirtualAssistantContext } from './context/context';

export enum VirtualAssistantIconWebsocketAction {
  GlowingOn = 'GLOWING_ON',
  GlowingOff = 'GLOWING_OFF',
  Enable = 'ENABLE',
  Disable = 'DISABLE',
}

export const useVirtualAssistant = () => {
  const { setIsActive, setIsGlowing } = useVirtualAssistantContext();

  return useCallback(function (payload: string) {
    switch (payload) {
      case VirtualAssistantIconWebsocketAction.GlowingOn: {
        setIsGlowing(true);
        break;
      }

      case VirtualAssistantIconWebsocketAction.GlowingOff: {
        setIsGlowing(false);
        break;
      }

      case VirtualAssistantIconWebsocketAction.Enable: {
        setIsActive(true);
        break;
      }

      case VirtualAssistantIconWebsocketAction.Disable: {
        setIsActive(false);
        break;
      }
    }
  }, []);
};
